import { CRTMSG, DELMSG, UPTMSG } from 'src/Helper/toastmsg';
import {
  EXPENSE_CREATE, EXPENSE_LIST, EXPENSE_SINGLE, EXPENSE_UPDATE, EXPENSE_DELETE, CLEAR_EXPENSE_TEMP_STATES, CLEAR_EXPENSE_STATES
} from '../../../../Helper/actionsTypes';

const expenseReducer = (state = [], action) => {
  const { code, results, message } = action.payload || ''
  switch (action.type) {
    case EXPENSE_LIST: {
      return code === 200
        ? { ...state, list: results }
        : { ...state, list: [] };
    }
    case EXPENSE_SINGLE: {
      return code === 200
        ? { ...state, single: results }
        : { ...state, single: {} };
    }
    case EXPENSE_DELETE: {
      return code === 200
        ? { ...state, itemDeleted: true, message }
        : code === 400 ? { ...state, itemDeleted: false, badReq: true, message }
          : code === 500 ? { ...state, itemDeleted: false, message: DELMSG }
            : { ...state, itemDeleted: false, message };
    }
    case EXPENSE_CREATE: {
      return code === 200
        ? { ...state, itemSaved: true, message }
        : code === 400 ? { ...state, itemSaved: false, badReq: true, message }
          : code === 500 ? { ...state, itemSaved: false, message: CRTMSG }
            : { ...state, itemSaved: false, message };
    }
    case EXPENSE_UPDATE: {
      return code === 200
        ? { ...state, itemUpdated: true, message }
        : code === 400 ? { ...state, itemUpdated: false, badReq: true, message }
          : code === 500 ? { ...state, itemUpdated: false, message: UPTMSG }
            : { ...state, itemUpdated: false, message };
    }
    case CLEAR_EXPENSE_TEMP_STATES: return { ...state, itemDeleted: null, itemSaved: null, itemUpdated: null, delete: {}, create: {}, update: {}, message: null, badReq:null };
    case CLEAR_EXPENSE_STATES: return {};
    default: return state;
  }
};

export default expenseReducer;